import fields from './fields'
import { combineReducers } from 'redux'


export default combineReducers({
    fields: fields
})